import { StoreState } from "store/index";

export const getCheapFlights = (state: StoreState) => state.cheapFlights;
